"use client";

import { analytics } from "@analytics";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

type TrackingEvent = {
  screen: string;
  userJourney: string;
  extras?: Record<string, unknown> | undefined;
};

export default function Analytics({
  screen,
  extras,
  userJourney,
}: TrackingEvent) {
  const pathname = usePathname();

  useEffect(() => {
    if (analytics && pathname) {
      analytics.page(`PassportDashboard${userJourney}${screen}`, {
        userJourney,
        screen,
        ...extras,
      });
    }
  }, [pathname, screen, userJourney, extras]);

  return null;
}
